import React from "react";

const Footer = () => {
  return (
    <>
      <div
        className="photon-muted-text shrink-0 py-5 sm:text-xs text-center w-full text-[10px]"
      >
        &copy; 2026{" "}
        <a
          href="https://quantumzero.io"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          QuantumZero Inc.
        </a>
      </div>
    </>
  );
};

export default Footer;

